import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handlePost } from '../../../utils/AxiosUtil';

class FinalizeSalary extends Component {

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const requestObject = {
            "privateId": this.props.row.privateId
        };
        handlePost(this.props.path, requestObject, this);
    };

    handleSuccess = (res) => {
        this.props.refresh();
        this.props.close();
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                <h3>{this.props.confirm}</h3>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Igen
                    </Button>
                </div>
            </form>

        )
    }
}

export default withSnackbar(FinalizeSalary);
